











































































import { genStateComputeds } from '@/main/pages/editFactory';
// eslint-disable-next-line no-unused-vars
import { Row, EditableStatus } from '@/main/utils/table';
import { NAME as name } from '@/modules/servis/zalohy/constants';
import { DmsBaseComponent } from '@/main/components/dms/common/base';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';

import { zalohyState } from './store/edit';

export default DmsBaseComponent.extend({
	name,
	components: {
		DmsEditableTable,
	},
	props: {
		storeUri: { type: String, required: true },
	},
	data() {
		return {
			tabItems: {
				zalohy: { id: 'Polozky', labelKey: 'pagePNVZalohaPol' },
				info: { id: 'info', labelKey: 'D_Info' },
			},
			zakZalohaPzn: 'ZAKZALOHA_PZN',
			povZalohaPzn: 'POVZALOHA_PZN',
		};
	},
	computed: {
		...genStateComputeds(zalohyState),
	},
	methods: {
		createRow() {
			(this.$refs.editableTable as any).createRow();
		},
		getZakzalohaPznText(row: Row, columnId: number) {
			return this.dropdownList.ZakzalohaPzn.find((item) => item.Value === row.cells[columnId])?.Text;
		},
		getPovzalohaPznText(row: Row, columnId: number) {
			return this.dropdownList.PovzalohaPzn.find((item) => item.Value === row.cells[columnId])?.Text;
		},
		updateRow(rowUpdateData: { tableName: string; updateStatus: EditableStatus; rowId: number; row: Row }) {
			this.$store.commit(`${this.storeUri}/updateTableRow`, rowUpdateData);
		},
		updateRows({ rows }: { rows: Row[] }) {
			this.dependentTables.Polozky.rows = rows;
		},
	},
});
